import React from 'react';
import Consumer from '../AppProvider';

class Contact extends React.Component {
   state = {
      name: '',
      phone: '',
      email: '',
      mess: ''
   };

   handleChange = prop => event => {
      this.setState({ [prop]: event.target.value });
   };
   render() {

      return (
         <Consumer>
            {ctx => {
               return (
                  <section id="contact" className="contact">
                     <div className="contact-decor">
                        <div className="contact-circle1"><img src="assets/images/main-banner12.png" alt="" /></div>
                        <div className="contact-circle2"><img src="assets/images/main-banner1.png" alt="" /></div>
                     </div>
                     <div className="container">
                        <div className="row">
                           <div className="col-md-12 col-lg-8 col-sm-12">
                              <div className="contact-us">
                                 <div className="w-100">
                                    <h2 className="title"><span>ΦΟΡΜΑ </span>ΕΠΙΚΟΙΝΩΝΙΑΣ</h2>
                                    <form className="theme-form" onSubmit={(e) => ctx.handleContact(e, this.state.name, this.state.phone, this.state.email, this.state.mess)}>
                                       <div className="form-group">
                                          <div className="row">
                                             <div className="col-sm-12 col-md-6 md-fgrup-margin">
                                                <input type="text" className="form-control" placeholder="Ονοματεπώνυμο" required="required" value={this.state.name} onChange={
                                                   this.handleChange("name")} />
                                             </div>
                                             <div className="col-sm-12 col-md-6">
                                                <input type="number" className="form-control" placeholder="Τηλέφωνο" required="required" value={this.state.phone} onChange={
                                                   this.handleChange("phone")} />
                                             </div>
                                          </div>
                                       </div>
                                       <div className="form-group">
                                          <input type="email" className="form-control" id="exampleFormControlInput1" placeholder="E-mail" required="required" value={this.state.email} onChange={
                                             this.handleChange("email")} />
                                       </div>
                                       <div className="form-group">
                                          <textarea className="form-control" id="exampleFormControlTextarea1" rows="4" placeholder="Το μήνυμα σας" required="required" value={this.state.mess} onChange={
                                             this.handleChange("mess")}></textarea>
                                       </div>
                                       {ctx.errMsg !== '' && <div className="alert alert-warning alert-dismissible fade show">
                                          {ctx.errMsg} <button type="button" className="close" data-dismiss="alert">&times;</button>
                                       </div>}
                                       <div className="form-button">
                                          <button type="submit" className="btn btn-custom theme-color">ΑΠΟΣΤΟΛΗ</button>
                                       </div>
                                    </form>
                                 </div>
                              </div>
                           </div>
                           <div className="col-lg-4 d-medium-none-lg">
                              <div className="contact-right">
                                 <img src="assets/images/Contact-info.png" className="img-fluid" alt="" />
                              </div>
                           </div>
                        </div>
                     </div>
                  </section>
               )
            }}
         </Consumer>
      );
   }
}


export default Contact;


// WEBPACK FOOTER //
// ./src/components/contact.js